import { SvgIcon, SvgIconProps } from "@mui/material";
import type { JSX } from "react";

export const PropertyTargetIcon = (props: SvgIconProps): JSX.Element => (
  <SvgIcon viewBox="0 0 45 45" fill="none" {...props}>
    {/* Outer circle */}
    <path
      d="M22.5 0.75C34.5122 0.75 44.25 10.4878 44.25 22.5C44.25 34.5122 34.5122 44.25 22.5 44.25C10.4878 44.25 0.75 34.5122 0.75 22.5C0.75 10.4878 10.4878 0.75 22.5 0.75Z"
      stroke="currentColor"
      strokeOpacity="0.4"
      strokeWidth="1.5"
      fill="none"
    />

    {/* Target / focus icon */}
    <path
      d="M26.6668 18.334V15.209L29.7918 12.084L30.8335 14.1673L32.9168 15.209L29.7918 18.334H26.6668ZM26.6668 18.334L22.5001 22.5006M32.9168 22.5007C32.9168 28.2536 28.2531 32.9173 22.5002 32.9173C16.7472 32.9173 12.0835 28.2536 12.0835 22.5007C12.0835 16.7477 16.7472 12.084 22.5002 12.084M27.7085 22.5007C27.7085 25.3771 25.3766 27.709 22.5002 27.709C19.6237 27.709 17.2918 25.3771 17.2918 22.5007C17.2918 19.6242 19.6237 17.2923 22.5002 17.2923"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </SvgIcon>
);
